/**
 * Returns the last finished step in booking funnel
 *
 * @return {String | null}
 */
export function getLastFinishedStep(draft): String {
  let lastStep = null

  if (isServicesFinished(draft.service)) {
    lastStep = 'service'
  } else {
    return lastStep
  }

  if (isCareReceiverFinished(draft.care_receiver)) {
    lastStep = 'care_receiver'
  } else {
    lastStep = 'service'
    return lastStep
  }

  if (isScheduleFinished(draft.scheduling)) {
    lastStep = 'scheduling'
  } else {
    lastStep = 'care_receiver'
    return lastStep
  }

  if (isPayFinished(draft.payment)) {
    lastStep = 'payment'
  }

  return lastStep
}

/**
 * Returns the status of services
 *
 * @return {Boolean}
 */
function isServicesFinished(services): Boolean {
  if (!services) {
    return false
  }

  return true
}

/**
 * Returns the status of care receiver
 *
 * @return {Boolean}
 */
function isCareReceiverFinished(careReceiver): Boolean {
  if (!careReceiver) {
    return false
  }

  return true
}

/**
 * Returns the status of schedule
 *
 * @return {Boolean}
 */
function isScheduleFinished(schedule): Boolean {
  if (!schedule) {
    return false
  }

  return true
}

/**
 * Returns the status of payement
 *
 * @return {Boolean}
 */
function isPayFinished(pay): Boolean {
  if (!pay) {
    return false
  }

  return true
}
